import { useMemo } from 'react'
import hash from 'object-hash'
import useQuery from './useQuery'

export default function useAutoSaveKey(
  preFillData: Record<string, unknown> | undefined,
) {
  const { previousFormSubmissionApprovalId, trackingCode } = useQuery()

  const preFillDataHashId = useMemo(() => {
    if (preFillData) {
      return hash(preFillData)
    }
  }, [preFillData])

  return useMemo(() => {
    return [
      typeof trackingCode === 'string' ? trackingCode : 'NO_TRACKING_CODE',
      preFillDataHashId || 'NO_PRE_FILL_DATA_HASH_ID',
      typeof previousFormSubmissionApprovalId === 'string'
        ? `PREVIOUS_FORM_SUBMISSION_APPROVAL_ID_${previousFormSubmissionApprovalId}`
        : 'NO_PREVIOUS_FORM_SUBMISSION_APPROVAL_ID',
    ].join('_')
  }, [trackingCode, preFillDataHashId, previousFormSubmissionApprovalId])
}
